import React, { useState, useEffect, useRef } from "react";
import Modal from 'react-modal';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { CiClock2, CiCalendar } from "react-icons/ci";
import BookingService from "../services/booking.service";
import ProductService from "../services/product.service";
import CategoryService from "../services/category.service";
import UserService from "../services/user.service";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import cantons from "../shared/data/cantons.json";
import { useNotifications } from '../context/NotificationProvider';
import { formatTimeTo24Hour } from "../shared/utils/string";
import { Map } from "../components/google_map";
import axios from "../api/axios";
import useAuth from "../hooks/useAuth";
import Autocomplete from 'react-google-autocomplete';
import { useLoadScript } from '@react-google-maps/api';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import imageFile from "../assets/images/upload-file.svg";
import { PhoneInput } from 'react-international-phone';
import HotelService from "../services/hotel.service";
import CalendarManagementService from '../services/calendar_management.service';
import { asTitle } from "../shared/utils/string";
import { useTranslation } from 'react-i18next';
import { useTranslatableData } from '../hooks/useTranslatable';
import PromotionService from "../services/promotion.service";
import { set } from "date-fns";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        position: 'absolute',
        boxshadow: '0 0 10px rgba(0, 0, 0, 0.5)',
        overflowX: 'hidden',
        scrollbarWidth: 'none',
        height: '680px',
    },
};


const customSelectStyles = {
    control: (styles) => ({
        ...styles,
        width: '100%',
        height: '60px',
        padding: '0 15px',
        fontSize: '14px',
        lineHeight: '60px',
        color: '#393D44',
        border: '0',
        borderRadius: '20px',
        background: '#ffffff',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
};

const CreateTaskModal = ({ api, onSuccess, bookingToDuplicate, onClose }) => {
    const { t, i18n } = useTranslation(['booking', 'customer', 'service', 'alerts']);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalAddOpen, setModalAddOpen] = useState(false);
    const [timePickerIsOpen, setTimePickerIsOpen] = useState(false);
    const [datePickerIsOpen, setDatePickerIsOpen] = useState(false);
    const [value, setValue] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState(new Date());
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [productList, setProductList] = useState([]);

    // Use translated data for display
    const translatedCategories = useTranslatableData(categories);
    const translatedSubCategories = useTranslatableData(subCategories);
    const translatedProductList = useTranslatableData(productList);
    const [flypros, setFlypros] = useState([]);
    const [flyprosLigit, setFlyprosLigit] = useState([]);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertMessagePromo, setAlertMessagePromo] = useState('');
    const [customers, setCustomers] = useState([]);
    const [isAddressUpdate, setIsAddressUpdate] = useState(false);
    const [coordinates, setCoordinate] = useState({ lat: 46.356, lng: 6.5641 });
    const [selectedState, setSelectedState] = useState(null);
    const [showMap, setShowMap] = useState(false);
    const [selectedFlyproOption, setSelectedFlyproOption] = useState([]);
    const [duplicatedCustomerOption, setDuplicatedCustomerOption] = useState(null);
    const notify = useNotifications();
    const { auth } = useAuth();
    const userRoles = auth?.roles;
    const isPrivileged = userRoles?.some(role => role.name === "ROLE_ADMIN");
    const [isZipCodeVisible, setIsZipCodeVisible] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [fileName, setFileName] = useState("");
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);
    const [newCustomerId, setNewCustomerId] = useState(null);
    const [hotels, setHotels] = useState([]);
    const [selectedHotel, setSelectedHotel] = useState(null);
    const [selectedProductOptionsPlus, setSelectedProductOptions] = useState([]);
    const [productQuantities, setProductQuantities] = useState({});
    const [promotions, setPromotions] = useState([]);


    function getBrowserInfo() {
        const ua = navigator.userAgent;
        let tem,
            M = ua.match(/(opera|chrome|safari|firefox|edg|msie|trident(?=\/))\/?\s*([\d.]+)/i) || [];
        let browserName, browserVersion;

        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+([\d.]+)/g.exec(ua) || [];
            browserName = 'IE';
            browserVersion = tem[1] || '';
        } else if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edg|Edge)\/([\d.]+)/);
            if (tem != null) {
                browserName = tem[1].replace('OPR', 'Opera').replace('Edg', 'Edge');
                browserVersion = tem[2];
            } else {
                browserName = M[1];
                browserVersion = M[2];
            }
        } else {
            browserName = M[1] || navigator.appName;
            browserVersion = M[2] || navigator.appVersion;
        }

        // Get the OS/platform
        let os = "Unknown";
        if (navigator.userAgent.indexOf("Win") !== -1) os = "Windows";
        else if (navigator.userAgent.indexOf("Mac") !== -1) os = "MacOS";
        else if (navigator.userAgent.indexOf("X11") !== -1) os = "UNIX";
        else if (navigator.userAgent.indexOf("Linux") !== -1) os = "Linux";
        else if (navigator.userAgent.indexOf("Android") !== -1) os = "Android";
        else if (navigator.userAgent.indexOf("iPhone") !== -1) os = "iOS";
        else if (navigator.userAgent.indexOf("iPad") !== -1) os = "iOS";
        else if (navigator.userAgent.indexOf("webOS") !== -1) os = "webOS";
        else if (navigator.userAgent.indexOf("Chrome OS") !== -1) os = "Chrome OS";

        return {
            browser: browserName,
            version: browserVersion,
            os: os
        };
    }
    const getTodayZurich = () => {
        const now = new Date();
      
        const formatter = new Intl.DateTimeFormat("en-CA", {
          timeZone: "Europe/Zurich",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      
        return formatter.format(now);
    };
      

    const [formData, setFormData] = useState({
        category_id: "",
        subcategory_id: "",
        products: [null],
        duration: "",
        date: "",
        date_only: getTodayZurich(),
        timeBooking: "",
        description: "",
        message: "",
        postcode: "",
        therapist_id: [],
        client_id: "",
        address_id: "",
        status: "CREATED",
        zip_code: "",
        state: "",
        state_code: "",
        street: "",
        street_number: "",
        city: "",
        country: "Switzerland",
        country_code: "CH",
        latitude: null,
        longitude: null,
        hotel_id: auth.user.hotel[0]?.id,
        total_fare: 0,
        subtotal: 0,
        offline_payment: true,
        room: "",
        promocode: "",
    });

    const loadCustomerOptions = async (inputValue, callback) => {
        try {
            if (!inputValue || inputValue.length < 3) {
                callback([]);
                return;
            }
            const response = await UserService.indexByRole(
                { with: 'primary_address', status: '!eq:BLOCKED', name: `contains:${inputValue}` },
                'ROLE_CLIENT',
                api
            );
            setCustomers(response);
            const options = response.map(customer => ({
                value: customer.id,
                label: `${customer.id} - ${customer.extra?.full_name}`
            }));
            callback(options);
        } catch (error) {
            console.error("Error loading customer options", error);
            callback([]);
        }
    };

    useEffect(() => {
        if (!bookingToDuplicate) return;

        const initializeForm = async () => {
            const {
                client_id,
                therapists,
                products,
                clients,
                duration,
                description,
                message,
                address_id,
                address = {},
                hotel_id,
                hotel,
                total_fare,
                subtotal,
                room_type,
                promocode,
                offline_payment
            } = bookingToDuplicate;

            const {
                zip_code = '',
                state = '',
                state_code = '',
                street = '',
                street_number = '',
                city = '',
                country = 'Switzerland',
                country_code = 'CH',
                latitude = null,
                longitude = null
            } = address;

            const therapistsArray = typeof therapists === 'string'
                ? therapists.split(',').filter(Boolean)
                : Array.isArray(therapists) ? therapists : [];

            const productsArray = typeof products === 'string'
                ? products.split(',').filter(Boolean)
                : Array.isArray(products) ? products : [];

            const clientsArray = typeof clients === 'string'
                ? clients.split(',').filter(Boolean)
                : Array.isArray(clients) ? clients : [];

            const categoryIds = Array.from(
                new Set(
                    products
                        .map(p => {
                            // If category has a parent_id, it's a subcategory - use parent_id for categoryIds
                            // If category has no parent_id, it's a parent category - use its own id for categoryIds
                            return p?.category?.parent_id || p?.category?.id;
                        })
                        .filter(Boolean)
                )
            )

            const subcategoryIds = Array.from(
                new Set(
                    products
                        .map(p => {
                            // Only include in subcategoryIds if the category actually has a parent
                            return p?.category?.parent_id ? p?.category?.id : null;
                        })
                        .filter(Boolean)
                )
            )

            console.log({ productsArray })
            console.log({ therapistsArray })
            console.log('flypro data', therapistsArray.map(t => t.id))

            // Set the form data
            setFormData(prev => ({
                ...prev,
                client_id,
                therapist_id: therapistsArray.map(t => t.id),
                products: productsArray.length ? productsArray.map(p => p.id) : [null],
                product_id: productsArray.length ? productsArray[0].id : null,
                category_id: categoryIds || [],
                subcategory_id: subcategoryIds || [],
                duration,
                description: description || "",
                message: message || "",
                address_id: address_id || "",
                zip_code,
                state,
                state_code,
                street,
                street_number,
                city,
                country,
                country_code,
                latitude,
                longitude,
                hotel_id: hotel_id || auth.user.hotel?.[0]?.id,
                total_fare: productsArray.length ? productsArray?.reduce((total, p) => total + p.price, 0) : total_fare || 0,
                subtotal: productsArray.length ? productsArray?.reduce((total, p) => total + p.price, 0) : subtotal || 0,
                date: "",
                date_only: getTodayZurich(),
                timeBooking: "",
                status: "CREATED",
                offline_payment: true,
                room: room_type,
                // promocode,
            }));

            setCoordinate({
                lat: address.latitude,
                lng: address.longitude,
            });

            setProductList(productsArray);
            if (categoryIds.length) {
                const results = await Promise.all(
                    categoryIds.map(async (id) => {
                        const [subCategoriesRes, prodsRes] = await Promise.all([
                            CategoryService.index({ parent_id: id, status: 'ACTIVE', with: 'domain,domain.hotel' }, api),
                            ProductService.index({ category_id: id, status: 'ACTIVE', with: 'category,category.parent' }, api)
                        ]);
                        return { subCategoriesRes, prodsRes };
                    })
                );

                const allSubCategories = results.flatMap(res => res.subCategoriesRes);
                const allProducts = results.flatMap(res => res.prodsRes);

                // Only update subcategories if we don't already have them loaded
                if (!hotel_id || subCategories.length === 0) {
                    setSubCategories(allSubCategories);
                }
                // Merge with existing products instead of overwriting
                setProductList(prevProducts => {
                    const existingIds = new Set(prevProducts.map(p => p.id));
                    const newProducts = allProducts.filter(p => !existingIds.has(p.id));
                    return [...prevProducts, ...newProducts];
                });
            }
            if (subcategoryIds.length) {
                Promise
                    .all(subcategoryIds.map(id =>
                        ProductService.index({ category_id: id, status: 'ACTIVE', with: 'category,category.parent' }, api)
                    ))
                    .then(results => {
                        const newProducts = results.flat();
                        setProductList(prevProducts => {
                            const existingIds = new Set(prevProducts.map(p => p.id));
                            const filteredNewProducts = newProducts.filter(p => !existingIds.has(p.id));
                            return [...prevProducts, ...filteredNewProducts];
                        });
                    });
            }
            try {
                const [categoriesRes, hotelsRes] = await Promise.all([
                    CategoryService.index({ parent_id: null, status: 'ACTIVE', with: 'domain,domain.zones,domain.hotel' }, api),
                    // UserService.indexByRole({ with: 'primary_address' }, 'ROLE_CLIENT', api),
                    HotelService.index({ with: 'address,addresses' }, api)
                ]);
                setHotels(hotelsRes);

                if (client_id) {
                    const customersRes = await UserService.indexByRole({ id: client_id, with: 'primary_address' }, 'ROLE_CLIENT', api);
                    setCustomers(customersRes);
                }

                if (hotel_id) {

                    const allCats = await CategoryService.index({ parent_id: null, status: 'ACTIVE', with: 'domain,domain.hotel' }, api);
                    const hotelCategories = allCats.filter(c => c.domain?.hotel_id === hotel_id);
                    setCategories(hotelCategories);

                    // Load subcategories for hotel categories only
                    if (categoryIds.length > 0) {
                        const hotelSubCategoryPromises = categoryIds.map(catId =>
                            CategoryService.index({ parent_id: catId, status: 'ACTIVE', with: 'domain,domain.hotel' }, api)
                        );
                        const hotelSubCategories = (await Promise.all(hotelSubCategoryPromises)).flat();
                        setSubCategories(hotelSubCategories);
                    }
                } else {

                    const allParentCategories = await CategoryService.index({ parent_id: null, status: 'ACTIVE', with: 'domain,domain.hotel' }, api);
                    const filteredCategories = allParentCategories.filter(cat => {
                        return !cat.domain?.hotel_id;
                    });
                    
                    let categoriesToSet = [...filteredCategories];
                    // let categoriesToSet = [...allParentCategories];

                    let subCategoriesToSet = [];
                    if (categoryIds.length > 0) {
                        const subCategoryPromises = categoryIds.map(catId =>
                            CategoryService.index({ parent_id: catId, status: 'ACTIVE', with: 'domain,domain.hotel' }, api)
                        );
                        subCategoriesToSet = (await Promise.all(subCategoryPromises)).flat();
                    }


                    const missingCategoryIds = categoryIds.filter(
                        id => !categoriesToSet.some(cat => cat.id === id)
                    );
                    if (missingCategoryIds.length) {
                        const missingCats = await Promise.all(
                            missingCategoryIds.map(id => CategoryService.get(id, {}, api))
                        );
                        categoriesToSet = [...categoriesToSet, ...missingCats];
                    }

                    const missingSubcategoryIds = subcategoryIds.filter(
                        id => !subCategoriesToSet.some(sub => sub.id === id)
                    );
                    if (missingSubcategoryIds.length) {
                        const missingSubs = await Promise.all(
                            missingSubcategoryIds.map(id => CategoryService.get(id, {}, api))
                        );
                        subCategoriesToSet = [...subCategoriesToSet, ...missingSubs];
                    }

                    setCategories(categoriesToSet);
                    setSubCategories(subCategoriesToSet);
                }

                // const selectedCustomer = customersRes.find(c => c.id === (newCustomerId || client_id));
                // setDuplicatedCustomerOption(
                //     selectedCustomer
                //         ? { value: selectedCustomer.id, label: selectedCustomer.extra?.full_name }
                //         : null
                // );
            } catch (error) {
                notify.error(t('errorInitializingForm', { ns: 'booking' }));
            }

            if (hotel_id) {
                const hotelProducts = await ProductService.index({ hotel_id: hotel_id }, api);
                setProductList(hotelProducts);
                setSelectedHotel(hotel_id);
            }

            if (therapistsArray.length) {
                setSelectedFlyproOption(therapistsArray.map(t => ({
                    value: t.id,
                    label: t.extra?.full_name
                })));
            }

            if (productsArray?.length) {
                const uniqueProductsMap = {};
                const quantities = {};

                productsArray.forEach(p => {
                    quantities[p.id] = (quantities[p.id] || 0) + 1;

                    if (!uniqueProductsMap[p.id]) {
                        uniqueProductsMap[p.id] = {
                            value: p.id,
                            label: `${p.name} - ${p.duration} min`,
                            duration: p.duration,
                            price: p.price
                        };
                    }
                });

                setSelectedProductOptions(Object.values(uniqueProductsMap));
                setProductQuantities(quantities);
            }


        };

        initializeForm();
        fetchAvailableTherapists();
    }, [bookingToDuplicate]);


    useEffect(() => {
        console.log({ bookingToDuplicate });
        console.log({ modalIsOpen });

        if (bookingToDuplicate) {
            setIsOpen(true);
        }
    }, [bookingToDuplicate]);


    useEffect(() => {
        if (formData.zip_code) {
            const filteredCategories = filterCategoriesByZipCode(categories, formData.zip_code);
            // setCategories(filteredCategories);
        }
    }, [formData.zip_code]);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ['places'],
    });

    const resetForm = () => {
        setFormData({
            category_id: "",
            subcategory_id: "",
            products: [null],
            duration: "",
            date: "",
            date_only: getTodayZurich(),
            timeBooking: "",
            description: "",
            message: "",
            postcode: "",
            therapist_id: [],
            client_id: "",
            address_id: "",
            status: "CREATED",
            zip_code: "",
            state: "",
            state_code: "",
            street: "",
            street_number: "",
            city: "",
            country: "Switzerland",
            country_code: "CH",
            latitude: null,
            longitude: null,
            hotel_id: auth.user.hotel[0]?.id,
            total_fare: 0,
            subtotal: 0,
            offline_payment: true,
            room: "",
            promocode: "",
        });
        setSelectedFlyproOption([]);
        setSubCategories([]);
        setProductList([]);
        setCoordinate({ lat: 46.356, lng: 6.5641 });
        setIsAddressUpdate(false);
        setSelectedProductOptions([]);
        setSelectedHotel(null);
        setNewCustomerId(null);
        setDuplicatedCustomerOption(null);
        setAlertMessage('');
        setAlertMessagePromo('');
        setCustomers([]);
    };

    useEffect(() => {
        if (formData.promocode) {
            handlePromoCodeValidation();
        }

    }, [formData.total_fare, formData.hotel_id, formData.products]);

    const fetchPromotions = async () => {
        try {
            const today = new Date().toISOString().split("T")[0];
            const response = await PromotionService.index(
                {
                    code: formData.promocode,
                    date_validity: `gte:${today}`,
                    is_active: 1,
                    with: 'usage',
                    ...(formData.hotel_id ? { gift: 1 } : {}),
                },
                api
            );
            // console.log("Promotion:", response[0]);
            if (response?.length > 0) {
                const promotion = response[0];
                if (promotion.extra?.zones_ranges?.length > 0) {
                    const zipCodeInt = parseInt(formData.zip_code, 10);
                    const isZipCodeValid = promotion.extra.zones_ranges.some(zone => {
                        const zoneInt = typeof zone === 'string' ? parseInt(zone, 10) : zone;
                        return zoneInt === zipCodeInt;
                    });
                    if (isZipCodeValid) {
                        console.log('Valid zip code found:', formData.zip_code);
                    } else {
                        setAlertMessagePromo(t("promo.invalid_zone"));
                        return;
                    }
                }
                if (promotion.all_clients) {
                    // console.log("Promotion:", response[0]);
                    return response[0];
                } else {
                    const clientResponse = await PromotionService.index(
                        {
                            id: promotion.id,
                            with: 'clients,usage',
                        },
                        api
                    );
                    // console.log("client Promotion:", clientResponse[0]);
                    const clientHasAccess = clientResponse[0]?.clients?.some(client => client.id === formData.client_id);

                    if (clientHasAccess) {
                        console.log("clientHasAccess", clientHasAccess);
                        return clientResponse[0];
                    } else {
                        setAlertMessagePromo(t("promo.invalid"));
                    }
                }
            } else {
                setAlertMessagePromo(t("promo.invalid"));
            }
        } catch (error) {
            console.error("Error fetching promotions", error);
        }
    };

    const handlePromoCodeValidation = async () => {

        const promotions = await fetchPromotions();
        // setDiscountedPrice(totalPrice);
        setPromotions(promotions);
        // console.log("promotions timeout:", promotions);

        const servicesfetch = await ProductService.index({ id: `in:${formData.products}`, status: 'ACTIVE', with: 'category,category.parent' }, api)
        // const expandedProducts = formData.products
        // .map(pid => servicesfetch.find(p => p.id === pid))
        // .filter(p => p);
        console.log(servicesfetch)
        const promo = promotions?.code === formData.promocode;
        //console.log("promo:", promo);

        if (promo) {
            const currentDate = new Date();
            const validityDate = new Date(promotions.date_validity);

            if (currentDate <= validityDate) {
                let newPrice = formData.subtotal;
                let remainingBalance;
                if (promotions.total_usage === -1) {
                    console.log("Total usage is unlimited.");
                }

                if (Array.isArray(promotions.usage) && promotions.usage.length >= 0) {
                    const usedPromotions = promotions.usage.filter(usage => usage.is_used);

                    if (promotions.total_usage !== -1 && usedPromotions.length >= promotions.total_usage) {
                        setAlertMessagePromo(t("promo.limit_reached"));
                        return;
                    }

                    const userUsage = promotions.usage.filter(
                        usage => usage.is_used && usage.client_id === auth?.user?.id
                    );

                    if (promotions.usage_per_customer !== -1 && userUsage.length >= promotions.usage_per_customer) {
                        setAlertMessagePromo(t("promo.user_limit_reached"));
                        return;
                    }
                    console.log(promotions)

                    if (promotions.type === "FREE_CREDITS") {
                        if (promotions.extra['remaining'] === 0) {
                            setAlertMessagePromo(t("promo.credit_expired"));
                            return;
                        }
                        const remainingCredits = promotions.usage
                            .filter(usage => usage.value > 0);
                        if (remainingCredits) {
                            promotions.amount = promotions.extra['remaining'];

                        }
                    }
                }

                let updatedTotalPrice = 0;
                let hasValidProduct = false;
                let durationMismatch = false;
                let remainingUses = promotions.total_usage;
                console.log(formData.products)

                servicesfetch.forEach(product => {
                    let newProductPrice = product.price;

                    const isValidProduct =
                        !promotions.product_id ||
                        product?.id === promotions.product_id;

                    if (isValidProduct) {
                        hasValidProduct = true;
                        if (promotions.type === "DURATION") {
                            if (product.hotel_id) {
                                setAlertMessagePromo(t("promo.invalid_for_hotels"));
                                return;
                            }

                            if (promotions.amount == product?.duration && (remainingUses > 0 || remainingUses === -1)) {
                                console.log("is valid duration");
                                newProductPrice = 0;
                                if (remainingUses !== -1) {
                                    remainingUses -= 1;
                                }
                            } else {
                                console.log("is noooo valid duration");
                                durationMismatch = true;
                                setAlertMessagePromo(t("promo.invalid_duration"));
                                newProductPrice = product.price;
                            }
                        } else if (promotions.type === "FREE") {
                            newProductPrice = 0;
                        } else if (promotions.type === "PERCENT_OFF") {
                            newProductPrice = product.price - (product.price * promotions.amount) / 100;
                        } else if (promotions.type === "FLATT_OFF" || promotions.type === "FREE_CREDITS") {
                            newProductPrice = Math.max(0, product.price - promotions.amount);
                        }
                    }

                    updatedTotalPrice += newProductPrice;
                });

                if (!hasValidProduct) {
                    setAlertMessagePromo(t("promo.invalid_products"));
                    return;
                }

                console.log("Updated Total Price:", updatedTotalPrice);


                setFormData(prev => ({
                    ...prev,
                    subtotal: updatedTotalPrice
                }));

                if (durationMismatch) {
                    setAlertMessagePromo(t("promo.invalid_duration"));
                    return;
                };

                setAlertMessagePromo(t("promo.applied"));

                if (remainingBalance >= 0) {
                    console.log(`Remaining balance after discount: ${remainingBalance}`);
                }

            } else {
                setAlertMessagePromo(t("promo.expired"));
            }
        }

        // const timer = setTimeout(() => setAlertMessagePromo(""), 3000);
        // return () => clearTimeout(timer);

    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!formData.client_id && selectedHotel) {
            setFormData(prev => ({
                ...prev,
                client_id: auth.user.id
            }));
        }
        if (isAddressUpdate || (formData.zip_code && !formData.latitude)) {
            try {
                await fetchCoordinates();
                setIsAddressUpdate(false);
            } catch (error) {
                notify.error(t('errorValidatingAddress'));
                return;
            }
        }
        let durationMax = null;
        if (selectedFlyproOption.length == 1) {
            console.log({ selectedFlyproOption })
            durationMax = formData.products.reduce((total, productId) => {
                const product = productList.find(p => p.id === productId);
                return total + (Number(product?.duration) || 0);
            }, 0);
            console.log({ durationMax })

        }

        try {
            //const state = cantons.cantons.find(c => c.name === formData.state);
            const time = formatTimeTo24Hour(formData.timeBooking);
            const combinedDateTime = `${formData.date_only} ${time}`;
            const products = selectedProductOptionsPlus.flatMap(p =>
                Array(productQuantities[p.value] || 1).fill(p.value)
            );

            const browser = getBrowserInfo();

            const payload = {
                ...formData,
                date: combinedDateTime,
                category_id: "",
                subcategory_id: "",
                product_id: formData.products[0],
                products,
                duration: durationMax ?? formData.duration,
                start_before: combinedDateTime,
                latitude: coordinates.lat,
                longitude: coordinates.lng,
                room_type: formData.hotel_id ? formData.room : null,
                device_type: `${browser.os} - ${browser.browser}`,
                locale: i18n.language,
                device_version: browser.version,
                promocode: alertMessagePromo === t("promo.applied") ? formData.promocode : ""
            };
            console.log("payload", payload)

            const response = await BookingService.store(payload, api);
            // if (response.data) {
            if (onSuccess) onSuccess();
            closeModal();
            // }
        } catch (error) {

        }
    };

    const openModal = async () => {
        console.log("Web Admin Panel ---", navigator.userAgentData);
        resetForm();
        try {
            const [categoriesRes, hotelsRes] = await Promise.all([
                CategoryService.index({ parent_id: null, status: 'ACTIVE', with: 'domain,domain.zones,domain.hotel' }, api),
                HotelService.index({ with: 'address,addresses' }, api)
            ]);
            const filteredCategories = categoriesRes.filter(cat => {
                return !cat.domain?.hotel_id;
            });
            setCategories(filteredCategories);
            // setCategories(categoriesRes);
            // setCustomers(customersRes);
            setHotels(hotelsRes);
            setIsOpen(true);
        } catch (error) {
            notify.error(t('errorInitializingForm', { ns: 'booking' }));
        }
    };

    const closeModal = () => {
        if (onClose) onClose();
        resetForm();
        setIsOpen(false);
    };

    // Handle category change
    const handleCategorySelectChange = async (selectedOptions) => {
        const selectedCategoryIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        if (bookingToDuplicate) {
            setFormData(prev => ({
                ...prev,
                category_id: selectedCategoryIds,
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                category_id: selectedCategoryIds,
                subcategory_id: '',
                products: [null],
            }));
        }

        if (selectedCategoryIds.length > 0) {
            try {
                const subCategoriesPromises = selectedCategoryIds.map(id =>
                    CategoryService.index({ parent_id: id, status: 'ACTIVE', with: 'domain,domain.hotel' }, api)
                );
                const productsPromises = selectedCategoryIds.map(id =>
                    ProductService.index({ category_id: id, status: 'ACTIVE', with: 'domain,domain.hotel' }, api)
                );

                const subCategoriesResponses = await Promise.all(subCategoriesPromises);
                const productsResponses = await Promise.all(productsPromises);

                const allSubCategories = subCategoriesResponses.flat();
                const allProducts = productsResponses.flat();

                setSubCategories(allSubCategories);
                setProductList(allProducts);
            } catch (error) {
                console.error("Error fetching subcategories or products", error);
            }
        } else {
            setSubCategories([]);
            setProductList([]);
        }
    };

    // Handle subcategory change
    const handleSubcategorySelectChange = async (selectedOptions) => {
        const selectedSubcatIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];

        setFormData(prev => ({
            ...prev,
            subcategory_id: selectedSubcatIds,
            products: [null],
        }));

        if (selectedSubcatIds.length > 0) {
            try {
                const productPromises = selectedSubcatIds.map(id =>
                    ProductService.index({ category_id: id }, api)
                );
                const productResponses = await Promise.all(productPromises);

                const allProducts = productResponses.flat();
                setProductList(allProducts);
            } catch (error) {
                console.error("Error fetching products by subcategories", error);
            }
        } else {
            setProductList([]);
        }
    };
    const recalculateBookingData = (selectedOptions, quantities) => {
        const selected = selectedOptions || [];

        const totalFare = selected.reduce((sum, p) => {
            const qty = quantities[p.value] || 1;
            return sum + (p.price || 0) * qty;
        }, 0);

        const totalDuration = Math.max(...selected.map(p => p.duration || 0));

        const productIds = selected.flatMap(p =>
            Array.from({ length: quantities[p.value] || 1 }, () => p.value)
        );

        setFormData(prev => ({
            ...prev,
            products: productIds,
            total_fare: totalFare,
            subtotal: totalFare,
            duration: totalDuration,
        }));
    };
    // Handle product change
    const handleProductSelectChange = (selectedOptions) => {
        const selected = selectedOptions || [];

        const updatedQuantities = { ...productQuantities };
        selected.forEach(option => {
            if (!updatedQuantities[option.value]) {
                updatedQuantities[option.value] = 1;
            }
        });

        setSelectedProductOptions(selected);
        setProductQuantities(updatedQuantities);
        recalculateBookingData(selected, updatedQuantities);
    };

    const incrementQuantity = (id) => {
        setProductQuantities(prev => {
            const currentQty = prev[id] || 1;
            if (currentQty >= 4) return prev;

            const newQuantities = {
                ...prev,
                [id]: currentQty + 1
            };

            setTimeout(() => recalculateBookingData(selectedProductOptionsPlus, newQuantities), 0);
            return newQuantities;
        });
    };


    const decrementQuantity = (id) => {
        setProductQuantities(prev => {
            const newQty = (prev[id] || 1) - 1;
            const newQuantities = { ...prev };

            if (newQty <= 0) {
                const updatedOptions = selectedProductOptionsPlus.filter(p => p.value !== id);
                setSelectedProductOptions(updatedOptions);
                delete newQuantities[id];
                setTimeout(() => recalculateBookingData(updatedOptions, newQuantities), 0);
            } else {
                newQuantities[id] = newQty;
                setTimeout(() => recalculateBookingData(selectedProductOptionsPlus, newQuantities), 0);
            }

            return newQuantities;
        });
    };



    // Handle flypro change
    const handleFlyproChange = async (selected) => {
        console.log({ selected });
        setAlertMessage('');

        if (selected.length > 2) {
            return;
        }

        if (selected?.length) {
            setSelectedFlyproOption(selected);
            setFormData((prev) => ({
                ...prev,
                therapist_id: selected.map((therapist) => therapist.value)
            }));

            const legitIds = flyproOptionsLigit.map(opt => opt.value);

            // Check each non-legit therapist
            for (const therapistObj of selected) {
                if (!legitIds.includes(therapistObj.value)) {
                    try {
                        const therapistId = therapistObj.value;

                        const response = await CalendarManagementService.index(
                            {
                                therapist_id: therapistId,
                                with: 'therapist.media,therapist.zones,therapist.categories,calendars_managements_slots.slot'
                            },
                            api
                        );
                        console.log('response calendrier :', response);


                        const { date_only, timeBooking } = formData;
                        const { latitude, longitude, category_id } = formData;
                        const selectedTime = formatTimeTo24Hour(timeBooking);

                        const availability = checkTherapistAvailability(response, date_only, selectedTime);
                        console.log('response availability :', availability);


                        const therapistData = response[0]?.therapist;
                        let locationMatch = false;
                        let locationMessage = '';
                        let categoryMatch = false;
                        let categoryMessage = '';

                        if (therapistData) {

                            const isZipInZone = (zipCode, zone) => {
                                if (!zone.zip_code) return false;

                                const zipPatterns = zone.zip_code.split(',');

                                for (const pattern of zipPatterns) {
                                    if (pattern.includes('-')) {
                                        const [start, end] = pattern.split('-').map(Number);
                                        const numericZip = Number(zipCode);
                                        if (numericZip >= start && numericZip <= end) {
                                            return true;
                                        }
                                    }
                                    else if (pattern === zipCode) {
                                        return true;
                                    }
                                }

                                return false;
                            };

                            if (formData.zip_code && therapistData.zones?.length > 0) {
                                locationMatch = therapistData.zones.some(zone =>
                                    zone.is_active && isZipInZone(formData.zip_code, zone)
                                );

                                if (!locationMatch) {
                                    if (therapistData.latitude && therapistData.longitude) {
                                        locationMatch = (
                                            Math.abs(therapistData.latitude - latitude) < 0.0001 &&
                                            Math.abs(therapistData.longitude - longitude) < 0.0001
                                        );
                                    }
                                }
                            } else if (therapistData.latitude && therapistData.longitude) {
                                locationMatch = (
                                    Math.abs(therapistData.latitude - latitude) < 0.0001 &&
                                    Math.abs(therapistData.longitude - longitude) < 0.0001
                                );
                            }

                            locationMessage = locationMatch
                                ? t('alerts:alerts.location.serves')
                                : t('alerts:alerts.location.notServes');

                            if (Array.isArray(category_id) && category_id.length > 0 && therapistData.categories?.length > 0) {
                                categoryMatch = therapistData.categories.some(
                                    cat => category_id.includes(cat.id) && cat.is_active
                                );

                                const matchingCategories = therapistData.categories
                                    .filter(cat => category_id.includes(cat.id) && cat.is_active)
                                    .map(cat => i18n.language === 'fr' && cat.title.fr ? cat.title.fr : cat.title.en);
                                const availableCategories = therapistData.categories
                                    .filter(cat => cat.is_active)
                                    .map(cat => i18n.language === 'fr' && cat.title.fr ? cat.title.fr : cat.title.en);

                                if (categoryMatch) {
                                    categoryMessage = t('alerts:alerts.category.offersSelected', {
                                        categories: matchingCategories.join(', ')
                                    });
                                } else {
                                    categoryMessage = t('alerts:alerts.category.notOffersSelected', {
                                        categories: availableCategories.join(', ')
                                    });
                                }
                            } else {
                                categoryMessage = t('alerts:alerts.category.noData');
                            }
                        } else {
                            locationMessage = t('alerts:alerts.location.noData');
                            categoryMessage = t('alerts:alerts.category.noData');
                        }

                        let message = '';
                        if (!availability.available) {
                            message = t('alerts:alerts.availability.unavailable', {
                                name: therapistObj.label,
                                reason: availability.reason
                            });
                        } else {
                            message = t('alerts:alerts.availability.available', {
                                name: therapistObj.label,
                                time: formData.timeBooking
                            });
                        }

                        message += ` ${locationMessage}, ${categoryMessage}`;

                        console.log(availability.available ? '✅' : '⚠️', message);
                        setAlertMessage(message);

                    } catch (error) {
                        console.error('Error checking availability:', error);
                    }
                }
            }

        } else {
            setSelectedFlyproOption([]);
            setFormData((prev) => ({
                ...prev,
                therapist_id: []
            }));
        }
    };

    function asTitles(status) {
        return t(`alerts:alerts.statusCalendar.${status}`);
    }

    const checkTherapistAvailability = (calendarData, selectedDate, selectedTime) => {

        console.log('response selectedDate :', selectedDate);

        const selectedDateISO = new Date(selectedDate).toISOString().split('T')[0]; // e.g., "2025-04-14"

        // Step 1: Find calendar entries matching the selected date
        const matchingCalendars = calendarData.filter(entry => {
            const date = new Date(entry.date);
            date.setDate(date.getDate());
            const calendarDate = date.toISOString().split('T')[0];
            return calendarDate === selectedDateISO;
        });

        if (!matchingCalendars.length) {
            return { available: false, reason: t('alerts:alerts.availability.noCalendar') };
        }

        // Step 2: Collect all slots from matching calendars
        const allSlots = matchingCalendars.flatMap(entry => entry.calendars_managements_slots || []);

        console.log('response matchingCalendars :', matchingCalendars);
        console.log('response allSlots :', allSlots);

        if (!allSlots.length) {
            return { available: true, reason: t('alerts:alerts.availability.noCalendar') };
        }

        // Step 3: Find a slot that matches the time
        const matchingSlot = allSlots.find(slotItem => {
            const slot = slotItem.slot;
            if (!slot) return false;

            const { start_time, end_time } = slot;

            return selectedTime >= start_time && selectedTime < end_time;
        });

        console.log('response matchingSlot :', matchingSlot);


        const ALLOWED_STATUSES = ['OVER_TIME', 'AVAILABLE'];

        if (!matchingSlot) {
            return { available: false, reason: t('alerts:alerts.availability.outsideSlots', { time: selectedTime }) };
        }

        if (!ALLOWED_STATUSES.includes(matchingSlot.status)) {
            if (matchingSlot.length > 1) {
                const availableSlots = matchingSlot
                    .filter(slotItem => {
                        const slot = slotItem.slot;
                        return slot && ALLOWED_STATUSES.includes(slotItem.status);
                    })
                    .map(slotItem => {
                        const slot = slotItem.slot;
                        return {
                            start: slot.start_time,
                            end: slot.end_time,
                            status: slotItem.status
                        };
                    });

                if (availableSlots.length > 0) {
                    // Find the closest slot to selectedTime
                    const closestSlot = availableSlots.reduce((closest, current) => {
                        const diffCurrent = Math.abs(parseTimeToMinutes(current.start) - parseTimeToMinutes(selectedTime));
                        const diffClosest = Math.abs(parseTimeToMinutes(closest.start) - parseTimeToMinutes(selectedTime));
                        return diffCurrent < diffClosest ? current : closest;
                    });

                    return {
                        available: false,
                        reason: t('alerts:alerts.availability.closestSlot', {
                            status: asTitle(matchingSlot.status),
                            time: selectedTime,
                            closestStart: closestSlot.start,
                            closestEnd: closestSlot.end,
                            closestStatus: asTitles(closestSlot.status)
                        })                    
                    };
                }
            } else {
                return { available: false, reason: t('alerts:alerts.availability.currentlyStatus', {
                            status: asTitles(matchingSlot.status)}) 
                        };
            }
        }

        return { available: true, reason: t('alerts:alerts.availability.therapistIsStatus', { status: asTitles(matchingSlot.status) }) };
    };

    const parseTimeToMinutes = (timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
    };


    // Handle Customer change
    const handleCustomerChange = async (selected) => {
        setCustomers(customers.filter(c => c.id === selected?.value) ?? customers);

        let client = await UserService.index(
            { id: selected?.value, with: 'primary_address' },
            api
        );
        console.log('customers', customers)
        console.log('client', client)
        console.log('client', client[0]?.primary_address)
        console.log('customer saved id', selected?.value)
        if (client && client[0]?.primary_address && !formData.hotel_id) {
            setFormData((prev) => ({
                ...prev,
                zip_code: client[0].primary_address?.zip_code,
                state: client[0].primary_address?.state,
                state_code: client[0].primary_address?.state_code,
                street: client[0].primary_address?.street,
                street_number: client[0].primary_address?.street_number,
                city: client[0].primary_address?.city,
                latitude: client[0].primary_address?.latitude,
                longitude: client[0].primary_address?.longitude,
                address_id: client[0].primary_address?.id,
                client_id: selected ? selected.value : ''
            }));
            setSelectedState({ value: client[0].primary_address.state, label: client[0].primary_address.state })
            setCoordinate({ lat: client[0].primary_address?.latitude, lng: client[0].primary_address?.longitude })
        } else if (formData.hotel_id) {
            setFormData((prev) => ({
                ...prev,
                client_id: selected ? selected.value : ''
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                zip_code: "",
                state: "",
                state_code: "",
                street: "",
                street_number: "",
                city: "",
                latitude: "",
                address_id: null,
                longitude: "",
                client_id: selected ? selected.value : ''
            }));
        }
    };

    // Create options for Category, Subcategory, Product, Flypro
    const categoryOptions = translatedCategories?.length > 0 ? translatedCategories.map(row => ({ value: row.id, label: `${row.domain?.hotel ? row.domain?.hotel?.name + ' - ' + row.title : row.title}` })) : [];
    const subcategoryOptions = translatedSubCategories?.length > 0 ? translatedSubCategories.map(row => ({ value: row.id, label: row.title })) : [];
    const productOptions = translatedProductList?.length > 0 ? translatedProductList.map(row => ({ value: row.id, label: `${row.name} - ${row.duration} min`, duration: row.duration, price: row.price })) : [];
    const flyproOptions = flypros?.length > 0 ? flypros.map(row => ({ value: row.id, label: row.extra?.full_name })) : [];
    const flyproOptionsLigit = flyprosLigit?.length > 0 ? flyprosLigit.map(row => ({ value: row.id, label: row.extra?.full_name })) : [];
    const customerOptions = customers?.length > 0 ? customers.map(row => ({ value: row.id, label: row.extra?.full_name })) : [];
    const hotelOptions = hotels.map(h => ({ value: h.id, label: h.name }));



    // Determine currently selected options
    const selectedCategoryOptions = categoryOptions.filter(o => formData.category_id?.includes(o.value));
    const selectedSubcategoryOptions = subcategoryOptions.filter(o => formData.subcategory_id?.includes(o.value));
    const selectedProductOptions = productOptions.filter(o => formData.products?.includes(o.value));
    // const selectedFlyproOption = flyproOptions.find(option => formData.therapist_id.includes(option.value)) || null;
    // const selectedCustomerOption = customerOptions.find(option => option.value === formData.client_id) || null;
    const selectedCustomer = customerOptions.find(
        option => option.value === (newCustomerId || formData.client_id)
    ) || null;

    const selectedCustomerOption = selectedCustomer ? { value: selectedCustomer.value, label: selectedCustomer.label } : null;

    // Fonction pour mettre à jour les valeurs du formulaire

    const handleChange = async (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const fetchCoordinates = async () => {
        const { street_number, street, city, state, zip_code } = formData;
        const address = `${street_number} ${street}, ${city}, ${state} ${zip_code}`;

        try {
            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json`,
                {
                    params: {
                        address,
                        key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
                    },
                }
            );

            if (response.data.results.length > 0) {
                const location = response.data.results[0].geometry.location;
                setFormData((prev) => ({
                    ...prev,
                    latitude: location.lat,
                    longitude: location.lng,
                }));
                setCoordinate({
                    lat: location.lat,
                    lng: location.lng,
                });
            } else {
                console.error('No results found for the given address.');
            }
        } catch (error) {
            console.error('Error fetching coordinates:', error);
        }
    };

    const handleShowMap = async () => {
        if (!showMap) {
            await fetchCoordinates();
            setShowMap(true);
        } else {
            setShowMap(false);
        }
    };

    useEffect(() => {
        const shouldLoad =
            formData.longitude &&
            formData.latitude &&
            formData.duration &&
            formData.date_only &&
            formData.timeBooking &&
            formData.state;

        const fetchData = async () => {
            try {
                if (shouldLoad) {
                    console.log("Fetching legit therapists... and all");
                    if (formData.hotel_id) {
                        await fetchAvailableTherapistsLigit();
                    }
                    await fetchAvailableTherapists();
                } else {
                    console.log("Fetching all therapists...");
                    await fetchAvailableTherapists();
                }
            } catch (error) {
                console.error("Error loading therapists:", error);
            }
        };

        fetchData();
    }, [
        formData.longitude,
        formData.latitude,
        formData.duration,
        formData.date_only,
        formData.timeBooking,
        formData.state,
        formData.hotel_id,
    ]);


    const fetchAvailableTherapists = async () => {
        try {
            const flypro = await UserService.indexByRole({
                with: 'primary_address',
                ...(!isPrivileged && { ['flypro_manager_id']: auth?.user?.id })
            }, 'ROLE_FLYPRO', api);
            const sortedFlypros = flypro.sort((a, b) =>
                (a.extra?.full_name || '').localeCompare(b.extra?.full_name || '', undefined, { sensitivity: 'base' })
            );
            setFlypros(sortedFlypros);
        } catch (error) {

        }
    }

    const fetchAvailableTherapistsLigit = async () => {
        try {
            console.log({ room_type: formData.hotel_id ? formData.room : null, hotel_id: formData.hotel_id, is_hotel: formData.hotel_id ? true : false, date: formData.date, time: formData.timeBooking, latitude: formData.latitude, longitude: formData.longitude })
            const flyproLigit = await UserService.fetchAvailableTherapists({ hotel_id: formData.hotel_id, is_hotel: formData.hotel_id ? true : false, room_type: formData.hotel_id ? formData.room : null, date: formData.date_only, time: formatTimeTo24Hour(formData.timeBooking), duration: Number(formData.duration), lat: formData.latitude, lng: formData.longitude, zip_code: formData.zip_code }, null, api);
            const sortedFlyprosLigit = flyproLigit.sort((a, b) =>
                (a.extra?.full_name || '').localeCompare(b.extra?.full_name || '', undefined, { sensitivity: 'base' })
            );
            setFlyprosLigit(sortedFlyprosLigit);
        } catch (error) {

        }
    }

    const handleCoordinateChange = (coordinates) => {
        setFormData({
            ...formData,
            longitude: coordinates[0]?.lng,
            latitude: coordinates[0]?.lat,
        })
        setCoordinate({
            lat: coordinates[0]?.lng,
            lng: coordinates[0]?.lat,
        })
    }

    const handleStateChange = (data) => {
        let selected = cantons.cantons.find(
            (canton) => canton.name === data?.value
        );
        document.querySelector('input[name="zip_code"]').setAttribute('placeholder', selected?.zip_code_range || '');

        setFormData((prev) => ({
            ...prev,
            zip_code: '',
            state: data?.value,
        }));

        setSelectedState(data);
    };

    const handlePlaceSelect = (place) => {
        if (!place || !place.address_components) {
            console.error("Invalid place selected");
            return;
        }

        let updatedAddress = {
            street: '',
            street_number: '',
            city: '',
            state: '',
            state_code: '',
            zip_code: '',
            country: 'Switzerland',
            country_code: 'CH',
            latitude: place.geometry?.location?.lat() || null,
            longitude: place.geometry?.location?.lng() || null,
        };

        place.address_components.forEach((component) => {
            const type = component.types[0];
            switch (type) {
                case "street_number":
                    updatedAddress.street_number = component.long_name;
                    break;
                case "route":
                    updatedAddress.street = component.long_name;
                    break;
                case "locality":
                    updatedAddress.city = component.long_name;
                    break;
                case "postal_code":
                    updatedAddress.zip_code = component.long_name;
                    break;
                case "administrative_area_level_1":
                    updatedAddress.state = component.long_name;
                    updatedAddress.state_code = component.short_name;
                    break;
            }
        });

        setFormData((prev) => ({
            ...prev,
            ...updatedAddress,
        }));

        // 🔹 Force update coordinates
        setCoordinate({
            lat: updatedAddress.latitude,
            lng: updatedAddress.longitude,
        });

        console.log("Updated Coordinates:", updatedAddress.latitude, updatedAddress.longitude);
        setShowMap(true); // 🔹 Ensure the map shows up
    };
    const filterCategoriesByZipCode = (categories, selectedZipCode) => {
        return categories.filter(category => {
            const domainZones = category.domain?.zones || [];
            return domainZones.some(zone => {
                const [startZip, endZip] = zone.zip_code.split('-').map(Number);
                const zipCodeNum = Number(selectedZipCode);
                return zipCodeNum >= startZip && zipCodeNum <= endZip;
            });
        });
    };

    const handlePlaceSelectClient = (place) => {
        if (!place || !place.address_components) {
            console.error("Invalid place selected");
            return;
        }

        let updatedAddress = {
            street: '',
            street_number: '',
            city: '',
            state: '',
            state_code: '',
            zip_code: '',
            country: 'Switzerland',
            country_code: 'CH',
            latitude: place.geometry?.location?.lat() || null,
            longitude: place.geometry?.location?.lng() || null,
        };

        place.address_components.forEach((component) => {
            const type = component.types[0];
            switch (type) {
                case "street_number":
                    updatedAddress.street_number = component.long_name;
                    break;
                case "route":
                    updatedAddress.street = component.long_name;
                    break;
                case "locality":
                    updatedAddress.city = component.long_name;
                    break;
                case "postal_code":
                    updatedAddress.zip_code = component.long_name;
                    break;
                case "administrative_area_level_1":
                    updatedAddress.state = component.long_name;
                    updatedAddress.state_code = component.short_name;
                    break;
            }
        });


        setformDataAdd((prev) => ({
            ...prev,
            ...updatedAddress,
        }));

        // 🔹 Force update coordinates
        setCoordinate({
            lat: updatedAddress.latitude,
            lng: updatedAddress.longitude,
        });

        console.log("Updated Coordinates:", updatedAddress.latitude, updatedAddress.longitude);
        setShowMap(true); // 🔹 Ensure the map shows up
    };
    const [formDataAdd, setformDataAdd] = useState({
        id: null,
        civility: null,
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
        birthdate: "",
        zip_code: "",
        state: "",
        state_code: "",
        street: "",
        street_number: "",
        city: "",
        country: "Switzerland",
        country_code: "CH",
        role: "ROLE_CLIENT",
        latitude: null,
        longitude: null
    });
    function openModalAdd(customer) {
        if (customer && customer?.id) {
            let phone = customer.phone;
            if (phone && phone.startsWith("0")) {
                phone = "+41" + phone.substring(1);
            }

            setFormData({
                ...formData,
                ...customer,
                ...{
                    primary_address_id: customer.primary_address?.id,
                    zip_code: customer.primary_address?.zip_code,
                    state: customer.primary_address?.state,
                    state_code: customer.primary_address?.state_code,
                    street: customer.primary_address?.street,
                    street_number: customer.primary_address?.street_number,
                    city: customer.primary_address?.city,
                    country: customer.primary_address?.country,
                    country_code: customer.primary_address?.country_code,
                    longitude: customer.primary_address?.longitude,
                    latitude: customer.primary_address?.latitude,
                    phone
                },
            });
            if (customer.primary_address?.state) {
                setSelectedState({
                    value: customer.primary_address?.state,
                    label: customer.primary_address?.state
                })
            }
            if (customer.primary_address?.longitude) {
                setCoordinate({
                    lat: customer.primary_address?.latitude,
                    lng: customer.primary_address?.longitude,
                })
            }
            setFile(null);
            setFileName("");

        }
        setShowMap(false);
        setModalAddOpen(true);
    }

    const handleChangeAdd = async (e) => {

        const updatedCivility = e.target.name === 'civility' ? (formDataAdd.civility === e.target.value ? "" : e.target.value) : formDataAdd.civility;

        const updatedformDataAdd = {
            ...formDataAdd,
            [e.target.name]: e.target.value,
            civility: updatedCivility,
        };

        if (formDataAdd.id && e.target.name === 'zip_code' || e.target.name === 'street' || e.target.name === 'street_number' || e.target.name === 'city') {
            setIsAddressUpdate(true);
        }

        // Handle file input
        if (e.target.name === "file") {
            console.log({ e });
            const file = e.target.files[0];
            if (file) {
                setFileName(file.name);
                setFile(file);
            }
        } else {
            setformDataAdd({
                ...formDataAdd,
                [e.target.name]: e.target.value,
            });
        }

        setformDataAdd({
            ...formDataAdd,
            [e.target.name]: e.target.value,
        });

        setformDataAdd(updatedformDataAdd);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        formDataAdd.birthdate = formDataAdd.birthdate === '' ? null : formDataAdd.birthdate;
        formDataAdd.role = 'ROLE_CLIENT';
        formDataAdd.country = "Switzerland";
        formDataAdd.country_code = "CH";

        const formDataAddToSend = new FormData();

        for (const key in formDataAdd) {
            const value = formDataAdd[key];
            if (value) {
                if (Array.isArray(value) || typeof value === 'object') {
                    formDataAddToSend.append(key, JSON.stringify(value));
                } else if (typeof value === 'boolean') {
                    formDataAddToSend.append(key, Number(value)); // Convert boolean to string
                } else {
                    formDataAddToSend.append(key, value);
                }
            }
        }

        if (file) {
            formDataAddToSend.append("imageFile", file);
        }

        try {
            const response = await (formDataAdd.id ? UserService.updateWithImage(formDataAdd.id, file ? formDataAddToSend : formDataAdd, file ? api : api) : UserService.store(file ? formDataAddToSend : formDataAdd, file ? api : api));
            if (response.data) {
                console.log("dd", response.data.id)
                setNewCustomerId(response.data.id)
                // const updatedCustomers = await UserService.indexByRole(
                //     { with: 'primary_address' },
                //     'ROLE_CLIENT',
                //     api
                // );
                // setCustomers(updatedCustomers);
                closeModalAdd();
                openModal();
                await handleCustomerChange({ value: response.data.id });
                setShowMap(false);
            }
        } catch (e) {
            // errors handled in interceptor
        }
    };
    function closeModalAdd() {
        setformDataAdd({
            id: null, //
            civility: null,
            firstname: "",
            lastname: "",
            phone: "",
            email: "",
            birthdate: "",
            zip_code: "",
            state: "",
            state_code: "",
            street: "",
            street_number: "",
            city: "",
            country: "Switzerland",
            country_code: "CH",
            role: "ROLE_CLIENT",
            latitude: null,
            longitude: null
        });
        setCoordinate({
            lat: 46.356,
            lng: 6.5641
        })
        setIsAddressUpdate(false);
        setModalAddOpen(false);
        setSelectedState(null);
    }
    const handlePhoneChange = (value) => {
        setformDataAdd((prevFormData) => ({
            ...prevFormData,
            phone: value,
        }));
    };

    const handleHotelSelect = async (selected) => {

        if (!selected) {
            setSelectedHotel(null);
            const [categoriesRes] = await Promise.all([
                CategoryService.index({ parent_id: null, status: 'ACTIVE', with: 'domain,domain.zones,domain.hotel' }, api),
            ]);
            const filteredCategories = categoriesRes.filter(cat => {
                return !cat.domain?.hotel_id;
            });
            
            setCategories(filteredCategories);
            // setCategories(categoriesRes);
            setFormData((prev) => ({
                ...prev,
                hotel_id: null,
                room: null,
                category_id: "",
                subcategory_id: "",
                products: [null],
            }));
            setSelectedProductOptions([]);


            return;
        }
        // if (categories?.length > 0) {
            const [categoriesHotel] = await Promise.all([
                CategoryService.index({ parent_id: null, status: 'ACTIVE', with: 'domain,domain.zones,domain.hotel' }, api),
            ]);
            const filtered = categoriesHotel.filter(
                c => c?.domain?.hotel_id === selected?.value
            );
            setCategories(filtered);
        // }

        setSelectedHotel(selected.value);

        const selectedHotel = hotels.find(h => h.id === selected.value);
        const address = selectedHotel?.address;

        console.log("Selected Hotel Address:", selectedHotel);

        if (!formData.client_id && selected.value) {
            setFormData(prev => ({
                ...prev,
                client_id: auth.user.id
            }));
        }


        setFormData((prev) => ({
            ...prev,
            hotel_id: selected.value,
            room: 'SPA_ROOM',
            category_id: "",
            subcategory_id: "",
            products: [null],
            address_id: address?.id || null,
            zip_code: address?.zip_code || "",
            state: address?.state || "",
            state_code: address?.state_code || "",
            street: address?.street || "",
            street_number: address?.street_number || "",
            city: address?.city || "",
            latitude: address?.latitude || "",
            longitude: address?.longitude || ""
        }));

        setCoordinate({
            lat: address?.latitude || 46.356,
            lng: address?.longitude || 6.5641
        });

        try {
            const hotelProducts = await ProductService.index({ hotel_id: selected.value }, api);
            setProductList(hotelProducts);
        } catch (err) {
            notify.error("Erreur lors du chargement des produits de l'hôtel");
        }
    };

    const filteredFlyproOptions = flyproOptionsLigit.length > 0
        ? flyproOptions.filter(opt => !flyproOptionsLigit.some(ligitOpt => ligitOpt.value === opt.value))
        : flyproOptions;

    const mergedOptions = flyproOptionsLigit.length > 0
        ? [
            {
                label: <div style={{ textAlign: 'center', color: '#888' }}>────────── Available Flypros ──────────</div>,
                value: '',
                isDisabled: true,
            },
            ...flyproOptionsLigit,
            {
                label: <div style={{ textAlign: 'center', color: '#888' }}>────────── All Flypros ──────────</div>,
                value: '',
                isDisabled: true,
            },
            ...filteredFlyproOptions,
        ]
        : [...flyproOptions];


    return (
        <>
            <button onClick={openModal} className="btn-add-client" style={{marginLeft: 'auto'}}>
                {t('createTask')}
            </button>

            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel={t('addBooking')}
            >
                <button className="close-button" onClick={closeModal}>
                    <span className="close-icon">✖</span>
                </button>

                <h2>{t('createTask')}</h2>
                <p>{t('infoNeeded')}</p>
                <div className="form-inscription">
                    <form onSubmit={handleFormSubmit}>
                        <div className="form-text">
                            <label>{t('customer')} *</label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions={customerOptions}
                                defaultInputValue={selectedCustomerOption?.label || ''}
                                loadOptions={loadCustomerOptions}
                                value={selectedCustomerOption || duplicatedCustomerOption}
                                onChange={handleCustomerChange}
                                options={customerOptions}
                                styles={customSelectStyles}
                                required={!selectedHotel}
                                isClearable
                                isSearchable
                                placeholder={t('selectCustomer')}
                                // noOptionsMessage={() => t('noCustomers')}
                                noOptionsMessage={() => (
                                    <div style={{ textAlign: "center" }}>
                                        <p>{t('noCustomers')}</p>
                                        <button className="button btn-clients" onClick={openModalAdd} style={{ padding: "5px 10px", cursor: "pointer" }}>
                                            {t('addCustomerBtn')}
                                        </button>
                                    </div>
                                )}
                            />

                        </div>
                        <div className="flex-row gap-10">
                            <div className="form-text">
                                <label htmlFor="street">{t('enterAddress')}</label>
                                <Autocomplete
                                    key={`${formData.street}-${formData.city}-${formData.zip_code}`}
                                    apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                                    onPlaceSelected={handlePlaceSelect}
                                    options={{
                                        types: ["address"],
                                        componentRestrictions: { country: "CH" },
                                    }}
                                    style={{
                                        height: "60px",
                                        padding: "0 15px",
                                        border: "0",
                                        borderRadius: "20px",
                                        boxShadow: "0px 8px 50px 0px rgba(0, 0, 0, 0.06)",
                                    }}
                                    defaultValue={
                                        formData.street
                                            ? `${formData.street_number} ${formData.street}, ${formData.city}, ${formData.state} ${formData.zip_code}`
                                            : ""
                                    }
                                    className={`address-input ${isZipCodeVisible ? "compact" : ""}`}
                                />
                            </div>

                            {isZipCodeVisible && (
                                <div className="form-group zip-code-input">
                                    <label>ZIP Code *</label>
                                    <input
                                        type="text"
                                        value={formData.zip_code}
                                        onChange={(e) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                zip_code: e.target.value,
                                            }));
                                        }}
                                        required
                                    />
                                </div>
                            )}

                            <div className="form-group icon-top-margin">
                                {formData.zip_code && (
                                    <img
                                        src="assets/images/map-icon.svg"
                                        alt="Map Icon"
                                        className="clickable"
                                        onClick={handleShowMap}
                                    />
                                )}
                            </div>
                        </div>
                        <div>
                            {formData.latitude && showMap && (<Map
                                coordinates={[coordinates]}
                                mode="edit"
                                containerStyle={{ width: '100%', height: '400px' }}
                                mapOptions={{
                                    disableDefaultUI: true,
                                    zoomControl: true,
                                    mapTypeControl: false,
                                    fullscreenControl: true,
                                    streetViewControl: false,
                                }}
                                onCoordinateChange={handleCoordinateChange}
                            />)}
                        </div>
                        <div className="form-text">
                            <label>Hotel</label>
                            <Select
                                value={hotelOptions.find(opt => opt.value === selectedHotel)}
                                onChange={(selected) => handleHotelSelect(selected)}
                                options={hotelOptions}
                                styles={customSelectStyles}
                                isClearable
                                placeholder="Select a Hotel"
                            />
                        </div>

                        {selectedHotel ? (
                            <div className="champs-notif" style={{ paddingBottom: '20px' }}>
                                <input
                                    type="checkbox"
                                    checked={formData.room === 'SPA_ROOM'}
                                    onChange={() =>
                                        setFormData(prev => ({
                                            ...prev,
                                            room: prev.room === 'SPA_ROOM' ? null : 'SPA_ROOM'
                                        }))
                                    }
                                />
                                <label>{t('service:salle_massage')}</label>

                                <input
                                    type="checkbox"
                                    checked={formData.room === 'HOTEL_ROOM'}
                                    onChange={() =>
                                        setFormData(prev => ({
                                            ...prev,
                                            room: prev.room === 'HOTEL_ROOM' ? null : 'HOTEL_ROOM'
                                        }))
                                    }
                                />
                                <label>{t('service:chambre_massage')}</label>
                            </div>

                        ) : null}
                        <>
                            <div className="form-text">
                                <label>{t('category')} *</label>
                                <Select
                                    value={selectedCategoryOptions}
                                    onChange={handleCategorySelectChange}
                                    options={categoryOptions}
                                    styles={customSelectStyles}
                                    isClearable
                                    required={!bookingToDuplicate}
                                    isSearchable
                                    isMulti
                                    placeholder={t('selectCategory')}
                                    noOptionsMessage={() => t('noCategories')}
                                />
                            </div>

                            <div className="form-text">
                                <label>{t('subcategory')}</label>
                                <Select
                                    value={selectedSubcategoryOptions}
                                    onChange={handleSubcategorySelectChange}
                                    options={subcategoryOptions}
                                    styles={customSelectStyles}
                                    isClearable
                                    isSearchable
                                    isMulti
                                    placeholder={t('selectSubcategory')}
                                    noOptionsMessage={() => t('noSubcategories')}
                                    isDisabled={!formData.category_id?.length}
                                />
                            </div>
                        </>


                        <div className="form-text">
                            <label>{t('product')} *</label>
                            <Select
                                value={selectedProductOptionsPlus}
                                onChange={handleProductSelectChange}
                                options={selectedHotel
                                    ? productList.map(p => ({
                                        value: p.id,
                                        label: p.duration + ' min',
                                        duration: p.duration,
                                        price: p.price
                                    })) : productOptions}
                                isMulti
                                isClearable
                                isSearchable
                                styles={customSelectStyles}
                                required
                                placeholder={selectedHotel ? "Select hotel products" : "Select products"}
                                noOptionsMessage={() =>
                                    selectedHotel
                                        ? "No products found for this hotel"
                                        : "No products available"
                                }
                            />

                            {selectedProductOptionsPlus.length > 0 && (
                                <div className="selected-products mt-4">
                                    {selectedProductOptionsPlus.map((product) => {
                                        const qty = productQuantities[product.value] || 1;
                                        return (
                                            <div key={product.value} className="product-row">
                                                {/* <span>{product.label}</span> */}
                                                <div className="quantity-controls">
                                                    <button type="button" onClick={() => decrementQuantity(product.value)}>-</button>
                                                    <span>{qty}</span>
                                                    <button type="button" onClick={() => incrementQuantity(product.value)}>+</button>
                                                </div>
                                                <div className="summary">
                                                    {qty} Pers. X {product.label}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}


                        </div>


                        <div className="form-text">
                            {/* <label>{t('duration')}</label> */}
                            <input type="hidden" readOnly name="duration" value={formData.duration} onChange={(e) => setFormData({ ...formData, duration: e.target.value })} />
                        </div>

                        <div className="dates">
                            <div className="form-text dateOfTheBookingParent topMarg">
                                <label>{t('dateOfBooking')}</label>

                                <input
                                    type="date"
                                    name="date_only"
                                    value={formData.date_only}
                                    onChange={(e) => setFormData({ ...formData, date_only: e.target.value })}
                                />
                            </div>

                            <div className="form-text timeOfTheBookingParent topMarg">
                                <label>{t('timeOfBooking')}</label>
                                <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                                    <input
                                        type="time"
                                        value={formData.timeBooking}
                                        onChange={(e) => setFormData(prev => ({ ...prev, timeBooking: e.target.value }))}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-text topMargArea">
                            <label>{t('description')} {t('notVisible')}</label>
                            <textarea className="formTextArea" placeholder={t('write_message_admin')} name="description" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
                        </div>

                        <div className="form-text topMargArea">
                            <label>{t('comment')} {t('visible')}</label>
                            <textarea className="formTextArea" placeholder={t('write_message_client')} name="message" value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} />
                        </div>

                        <div className="form-text">
                            <label>{t('flypro')} *</label>
                            <Select
                                value={selectedFlyproOption}
                                onChange={handleFlyproChange}
                                options={mergedOptions}
                                styles={customSelectStyles}
                                isClearable
                                required
                                isSearchable
                                isMulti
                                placeholder={t('selectFlypro')}
                                noOptionsMessage={() => t('noFlypros')}
                            />
                        </div>

                        {alertMessage && <div className="alert">{alertMessage}</div>}

                        <div className="form-text">
                            <label>Promo CODE</label>
                            <input type="text" style={{ width: "80%"}} name="promocode" value={formData.promocode} onChange={(e) => setFormData({ ...formData, promocode: e.target.value })} />
                            <button 
                                type="button"
                                style={{
                                width: "20%",
                                height: "60px",
                                fontSize: "16px",
                                color: "#393d44",
                                fontFamily: "MarcellusRegular",
                                border: 0,
                                borderRadius: "15px",
                                cursor: "pointer",
                                padding: "10px",
                                }}
                                onClick={handlePromoCodeValidation}>Valider</button>
                        </div>

                        {alertMessagePromo && <div className="alert">{alertMessagePromo == t('promo.applied') ? `${alertMessagePromo} ${t("promo.remaining_is")}: ${formData.subtotal}CHF` : alertMessagePromo}</div>}

                        <div className="champs-notif">
                            <input
                                type="checkbox"
                                name="offline_payment"
                                checked={!formData.offline_payment && (formData.client_id || !formData.hotel_id)}
                                onChange={(e) =>
                                    setFormData((prev) => ({
                                        ...prev,
                                        offline_payment: !e.target.checked, // Invert the value
                                    }))
                                }
                            />
                            <label>Send payment email to client</label>
                        </div>

                        <button type="submit" className="btn-submit">
                            {t('createTaskSubmit')}
                        </button>
                    </form>
                </div>
            </Modal>
            <Modal
                isOpen={modalAddOpen}
                onRequestClose={closeModalAdd}
                ariaHideApp={false}

                style={customStyles}
            >
                <button className="close-button" onClick={closeModalAdd}>
                    <span className="close-icon">✖</span>
                </button>

                <h2>{t('addCustomer', { ns: 'customer' })}</h2>
                <div className="form-inscription">
                    <form onSubmit={handleSubmit}>
                        <div className="form-choix">
                            <div className="form-radio">
                                <input
                                    type="checkbox"
                                    name="civility"
                                    value="MS"
                                    id="madame"
                                    checked={formDataAdd.civility === "MS"}
                                    onChange={handleChangeAdd}
                                />
                                <label htmlFor="madame">{t('ms', { ns: 'customer' })}</label>
                            </div>
                            <div className="form-radio">
                                <input
                                    type="checkbox"
                                    name="civility"
                                    value="MR"
                                    id="monsieur"
                                    checked={formDataAdd.civility === "MR"}
                                    onChange={handleChangeAdd}
                                />
                                <label htmlFor="monsieur">{t('mr', { ns: 'customer' })} *</label>
                            </div>
                        </div>
                        <div className='flex-row gap-10'>
                            <div className="form-text">
                                <label>{t('firstname', { ns: 'customer' })} *</label>
                                <input required value={formDataAdd.firstname} type="text" name="firstname" onChange={handleChangeAdd} />
                            </div>

                            <div className="form-text">
                                <label>{t('lastname', { ns: 'customer' })} *</label>
                                <input required value={formDataAdd.lastname} type="text" name="lastname" onChange={handleChangeAdd} />
                            </div>
                        </div>

                        <div className="form-text">
                            <label>{t('phone', { ns: 'customer' })} *</label>
                            <PhoneInput
                                defaultCountry="ch"
                                type="tel"
                                name="phone"
                                value={formDataAdd.phone}
                                disableCountryGuess="true"
                                //hideDropdown="true"
                                forceDialCode="true"
                                // onChange={handlePhoneChange}
                                onChange={(phone) => handlePhoneChange(phone)}
                                required
                            />
                        </div>

                        <div className="form-text">
                            <label>{t('emailAddress', { ns: 'customer' })} *</label>
                            <input required value={formDataAdd.email} type="email" name="email" onChange={handleChangeAdd} />
                        </div>

                        {/* <div className="form-text">
                                            <label>Birthdate</label>
                                            <input
                                                type="date"
                                                name="birthdate"
                                                value={formDataAdd.birthdate}
                                                onChange={handleChangeAdd}
                                                max={calculateMinDate()} // Date maximum permise (il y a 18 ans)
                                            />
                                        </div> */}
                        <div className="flex-row gap-10">
                            <div className="form-text">
                                <label htmlFor="street">{t('selectAddress', { ns: 'customer' })}</label>
                                <Autocomplete
                                    apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                                    onPlaceSelected={handlePlaceSelectClient}
                                    options={{
                                        types: ["address"],
                                        componentRestrictions: { country: "CH" },
                                    }}
                                    style={{
                                        height: "60px",
                                        padding: "0 15px",
                                        border: "0",
                                        borderRadius: "20px",
                                        boxShadow: "0px 8px 50px 0px rgba(0, 0, 0, 0.06)",
                                    }}
                                    defaultValue={
                                        formDataAdd.street
                                            ? `${formDataAdd.street_number} ${formDataAdd.street}, ${formDataAdd.city}, ${formDataAdd.state} ${formDataAdd.zip_code}`
                                            : ""
                                    }
                                    className={`address-input ${isZipCodeVisible ? "compact" : ""}`}
                                />
                            </div>

                            {isZipCodeVisible && (
                                <div className="form-group zip-code-input">
                                    <label>ZIP Code *</label>
                                    <input
                                        type="text"
                                        value={formDataAdd.zip_code}
                                        onChange={(e) =>
                                            setformDataAdd((prev) => ({
                                                ...prev,
                                                zip_code: e.target.value,
                                            }))
                                        }
                                        required
                                    />
                                </div>
                            )}

                            <div className="form-group icon-top-margin">
                                {formDataAdd.zip_code && (
                                    <img
                                        src="assets/images/map-icon.svg"
                                        alt="Map Icon"
                                        className="clickable"
                                        onClick={handleShowMap}
                                    />
                                )}
                            </div>
                        </div>

                        {formDataAdd.latitude && showMap && (
                            <Map
                                coordinates={[coordinates]}
                                mode="edit"
                                containerStyle={{ width: '100%', height: '400px' }}
                                mapOptions={{
                                    disableDefaultUI: true,
                                    zoomControl: true,
                                    mapTypeControl: false,
                                    fullscreenControl: true,
                                    streetViewControl: false,
                                }}
                                onCoordinateChange={handleCoordinateChange}
                            />
                        )}

                        {/* <label className="fileLabel" htmlFor="file">
                                            Image to upload
                                        </label>
                                        <div className="fileField">
                                            <label htmlFor="file">
                                                <img className="imgFile" src={imageFile || ""} alt="File upload" />
                                                {fileName ? (
                                                    <div>Uploaded File: {fileName}</div>
                                                ) : (
                                                    <>
                                                        <div className="selectFileTo">Select file to upload</div>
                                                        <div className="orDragAnd">
                                                            or drag and drop, copy-paste files
                                                        </div>
                                                    </>
                                                )}
                                            </label>
                                            <input
                                                type="file"
                                                id="file"
                                                name="file"
                                                accept="image/*"
                                                onChange={handleChangeAdd}
                                                ref={fileInputRef}
                                                style={{ display: "none" }}
                                            />
                                        </div> */}
                        <button type="submit" className="btn-submit">
                            {formDataAdd.id ? t('update', { ns: 'customer' }) : t('create', { ns: 'customer' })}
                        </button>
                    </form>
                </div>
            </Modal>
        </>
    );
};

export default CreateTaskModal;